export default {"src":"/_next/static/media/careercon-tent.8b7e9a68.svg","height":24,"width":22};